export default __webpack_public_path__ + "static/media/avatar-mp-3-3.601a69f0.png";